import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { Button, Grid, Group, IconButton, Layout, Page, Tree } from "@/comn/components";
import { useFetch, useForm, useGrid, useStore, useToast, useModal, useTree, usePopup, usePage } from "@/comn/hooks";
import { LayoutGroup } from "framer-motion";
import { APIS, SF_APRV_RQST_PPUP_INFO, SG_APRV_PATH_RQST_LIST, SG_APRV_USR_LIST } from "./service/AprvService";

/*
 * Popup for Approval Request
 * !== 결재 요청 팝업 ==!
 */
export const AprvRqst = (props: any): any => {
    // const { id, params } = props;

    // console.log(props);

    // const { closeModal } = useModal();

    // // 1. AprvRqst에서 컴포넌트로 null을 return (빈 화면 팝업)
    // // 2. 받은 props로 로직수행
    // // 3. 2. 완료 후 closeModal() (빈 화면이지만 모달은 떠있는 상태 꼭 꺼야함)

    // const saveAprvRqstInfo = useFetch({
    //     api: (data: any) => APIS.saveAprvRqstInfo(data),
    //     enabled: false,
    //     onSuccess: (data: any) => {
    //         modal.openModal({
    //             // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
    //             content: "msg.com.00058",
    //             onCancel: () => {
    //                 // !== 결재 요청시 생성된 결재 ID 가져오기 ==!
    //                 const getAprvId = data["aprvInfo"].content.aprvId;
    //                 modal.postMessage({
    //                     pgeUid: pgeUid,
    //                     menuId: menuId,
    //                     bsopClsfCd: bsopClsfCd,
    //                     afPrcssUrlAddr: afPrcssUrlAddr,
    //                     scrnDocCd: scrnDocCd,
    //                     aprvPrcssStatCd: "A01",
    //                     aprvId: getAprvId,
    //                 });
    //             },
    //         });
    //     },
    //     onError: () => {
    //         // Failed to save. !==  저장이 실패하였습니다. ==!
    //         toast.showToast({ type: "error", content: "msg.com.00026" });
    //         closeModal(id);
    //     },
    // });

    // useEffect(() => {
    //     const {
    //         bsopClsfCd,
    //         afPrcssUrlAddr,
    //         scrnDocCd,
    //         aprvId,
    //         aprvAfPrcssCfgnId,
    //         rtrnAfPrcssCfgnId,
    //         cnclAfPrcssCfgnId,
    //         rjctAfPrcssCfgnId,
    //         preStageRtrnUseYn,
    //         itsfAprvYn,
    //         delYn,
    //         aprvReffId,
    //     } = params;

    //     // saveAprvRqstInfo()
    // }, []);

    // return null;

    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const tree = useTree(); // Tree Hook !== Tree Hook ==!
    const { getParams } = usePopup();
    const {
        bsopClsfCd,
        afPrcssUrlAddr,
        scrnDocCd,
        aprvId,
        aprvAfPrcssCfgnId,
        rtrnAfPrcssCfgnId,
        cnclAfPrcssCfgnId,
        rjctAfPrcssCfgnId,
        preStageRtrnUseYn,
        itsfAprvYn,
        delYn,
        aprvReffId,
        rjctStatUseYn,
        docNo,
        aprvUsrMdfyYn,
        aprvPrcssPathMgmtId,
        aprvUsrList,
    } = getParams(); // Parameters to forward when calling a Approval request  결재요청 팝업 호출시 전달해야할 파라메터 (업무분류코드,결재후처리설정ID,신고문서코드)
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Approval Request Popup Information Form !== 결재 요청 팝업 정보 form ==!
        aprvRqstPpupInfo: useForm({
            defaultSchema: SF_APRV_RQST_PPUP_INFO,
            defaultValues: {},
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Approval Path Management List !== 결재선 관리 목록 조회(팝업사이즈용) ==!
        aprvPathMgmtList: useGrid({
            defaultSchema: SG_APRV_PATH_RQST_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        // Approver List !== 결재자 목록 ==!
        aprvUsrList: useGrid({
            defaultSchema: SG_APRV_USR_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Approval Path Management List !== 결재선 관리 목록 조회 ==!
        getAprvPathMgmtList: useFetch({
            api: (page = grid.aprvPathMgmtList.page) =>
                APIS.getAprvPathMgmtList(form.aprvRqstPpupInfo.getValues(), page, grid.aprvPathMgmtList.size),
            enabled: comnUtils.isEmpty(form.aprvRqstPpupInfo.errors),
            key: [grid.aprvPathMgmtList.page, grid.aprvPathMgmtList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.aprvRqstPpupInfo.getValues(),
                    page: grid.aprvPathMgmtList.page,
                    size: grid.aprvPathMgmtList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // When selecting an Approval Path, View the List of Target Approvers !== 결재선 클릭시 해당 결재선의 결재자 목록 조회 ==!
        getAprvTrgtList: useFetch({
            api: (page = grid.aprvUsrList.page) =>
                APIS.getAprvTrgtList(form.aprvRqstPpupInfo.getValues(), page, grid.aprvUsrList.size),
            enabled: comnUtils.isEmpty(form.aprvRqstPpupInfo.errors),
            key: [grid.aprvUsrList.page, grid.aprvUsrList.size],
            onSuccess: (data) => {
                if (!comnUtils.isEmpty(aprvPrcssPathMgmtId) && data.aprvUsrList.content.length === 0) {
                    fetch.getAprvTrgtList.fetch();
                }
                setStore(pgeUid, {
                    form: form.aprvRqstPpupInfo.getValues(),
                    page: grid.aprvUsrList.page,
                    size: grid.aprvUsrList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),

        // When selecting an Organization Chart, View the List of Target User List  !== 조직도 선택시 대상자 목록 조회 ==!
        getCstmList: useFetch({
            api: (data: any) => APIS.getCsmtList(),
            onSuccess: (data) => {
                const cstmList = data["cstmList"].content;
                tree.setData([
                    {
                        name: "Customs Office",
                        menuId: "menu_root",
                        menuPath: "ROOT",
                        children: handler.createTreeData(cstmList, [], 1, "menu_root"),
                    },
                ]);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // 조회가 실패하였습니다.
        }),

        getDclaDocInfo: useFetch({
            api: () => APIS.getDclaDocInfo(scrnDocCd),
            enabled: !!scrnDocCd,
            onSuccess: (data) => {
                const getDataInfo = data.dclaDocInfo.content;
                form.aprvRqstPpupInfo.setValues(getDataInfo);
                form.aprvRqstPpupInfo.setValue("aprvRqstTtleNm", getDataInfo.docNm);

                if (!comnUtils.isEmpty(aprvPrcssPathMgmtId)) {
                    console.log("aprvPrcssPathMgmtId" + aprvPrcssPathMgmtId);
                    handler.onGridAprvTrgtList(data);
                } else {
                    if (!comnUtils.isEmpty(aprvUsrList)) {
                        handler.onRqstUsrListAdd();
                    }
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Check Approval Path Information !== 결재 요청 정보 조회 ==!
        getAprvRqstInfo: useFetch({
            api: () => APIS.getAprvRqstInfo(aprvId),
            enabled: !!aprvId,
            onSuccess: (data) => {
                const getDataInfo = data.aprvRqstInfo.content;
                form.aprvRqstPpupInfo.setValue("aprvRqstCn", getDataInfo.aprvRqstCn);
                form.aprvRqstPpupInfo.setValue("aprvRqstTtleNm", getDataInfo.aprvRqstTtleNm);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),

        getAprvRqstUsrList: useFetch({
            api: (data: any) => APIS.getAprvRqstUsrList(data),
            onSuccess: (data) => {
                const getAprvRqstUsrList = data.rqstAprvUsrList.content;
                getAprvRqstUsrList.forEach((item: any, index: any) => {
                    grid.aprvUsrList.addRow({ ...item });
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // 조회가 실패하였습니다.
        }),

        // Create Organization Information !== 결재 요청 저장 ==!
        saveAprvRqstInfo: useFetch({
            api: (data: any) => APIS.saveAprvRqstInfo(data),
            enabled: false,
            onSuccess: (data: any) => {

                if (bsopClsfCd === 'CLR' || bsopClsfCd === 'PCA' || bsopClsfCd === 'COL') {
                    const getAprvId = data["aprvInfo"].content.aprvId; // !== 결재 요청시 생성된 결재 ID 가져오기 ==!
                    modal.postMessage({
                        pgeUid: pgeUid,
                        menuId: menuId,
                        bsopClsfCd: bsopClsfCd,
                        afPrcssUrlAddr: afPrcssUrlAddr,
                        scrnDocCd: scrnDocCd,
                        aprvPrcssStatCd: "A01",
                        aprvId: getAprvId,
                    });
                } else {
                    modal.openModal({
                        content: "msg.ptl.00814", // Request for approve has been completed. !== 결재요청이 완료되었습니다. ==!
                        onCancel: () => {
                            const getAprvId = data["aprvInfo"].content.aprvId; // !== 결재 요청시 생성된 결재 ID 가져오기 ==!
                            modal.postMessage({
                                pgeUid: pgeUid,
                                menuId: menuId,
                                bsopClsfCd: bsopClsfCd,
                                afPrcssUrlAddr: afPrcssUrlAddr,
                                scrnDocCd: scrnDocCd,
                                aprvPrcssStatCd: "A01",
                                aprvId: getAprvId,
                            });
                        },
                        onClose: () => {
                            const getAprvId = data["aprvInfo"].content.aprvId; // !== 결재 요청시 생성된 결재 ID 가져오기 ==!
                            modal.postMessage({
                                pgeUid: pgeUid,
                                menuId: menuId,
                                bsopClsfCd: bsopClsfCd,
                                afPrcssUrlAddr: afPrcssUrlAddr,
                                scrnDocCd: scrnDocCd,
                                aprvPrcssStatCd: "A01",
                                aprvId: getAprvId,
                            });
                        },
                    });
                }


            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00026" }), // Failed to save. !==  저장이 실패하였습니다. ==!
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        //Approval Request Button !== 결재요청 버튼 ==!
        onAprvBtnClick: () => {
            // const setList: any[] = grid.aprvUsrList.getData() || [];
            const setList: any[] = grid.aprvUsrList.getData({ excludes: ["deleted"] });
            if (!comnUtils.isEmpty(form.aprvRqstPpupInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }
            if (comnUtils.isEmpty(setList)) {
                modal.openModal({ content: "msg.00004" });
                return;
            }
            // save Information of !==  저장 ==!
            form.aprvRqstPpupInfo.handleSubmit(
                () => {
                    const usrDmnIds: string[] = [];
                    setList.forEach((item) => {
                        usrDmnIds.push(`${item.usrDmnId}`);
                    });
                    if (!comnUtils.isEmpty(aprvId)) {
                        form.aprvRqstPpupInfo.setValue("aprvId", aprvId);
                    }

                    form.aprvRqstPpupInfo.setValue("usrDmnId", usrDmnIds.join(","));
                    form.aprvRqstPpupInfo.setValue("bsopClsfCd", bsopClsfCd);
                    form.aprvRqstPpupInfo.setValue("afPrcssUrlAddr", afPrcssUrlAddr);
                    form.aprvRqstPpupInfo.setValue("scrnDocCd", scrnDocCd);
                    form.aprvRqstPpupInfo.setValue("aprvAfPrcssCfgnId", aprvAfPrcssCfgnId);
                    form.aprvRqstPpupInfo.setValue("rtrnAfPrcssCfgnId", rtrnAfPrcssCfgnId);
                    form.aprvRqstPpupInfo.setValue("cnclAfPrcssCfgnId", cnclAfPrcssCfgnId);
                    form.aprvRqstPpupInfo.setValue("rjctAfPrcssCfgnId", rjctAfPrcssCfgnId);
                    form.aprvRqstPpupInfo.setValue("preStageRtrnUseYn", preStageRtrnUseYn);
                    form.aprvRqstPpupInfo.setValue("itsfAprvYn", itsfAprvYn);
                    form.aprvRqstPpupInfo.setValue("delYn", delYn);
                    form.aprvRqstPpupInfo.setValue("aprvReffId", aprvReffId);
                    form.aprvRqstPpupInfo.setValue("rjctStatUseYn", rjctStatUseYn);
                    form.aprvRqstPpupInfo.setValue("docNo", docNo);
                    form.aprvRqstPpupInfo.setValue("aprvUsrMdfyYn", aprvUsrMdfyYn);

                    const data = form.aprvRqstPpupInfo.getValues();

                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveAprvRqstInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },

        createTreeData: (orgList: any, newList: any, level: any, menuId: any) => {
            const tempList = orgList.map((item: any) => {
                return {
                    name: comnUtils.replaceEmpty(item.cstmNm),
                    checkbox: false,
                    cstmOfceCd: comnUtils.replaceEmpty(item.cstmOfceCd),
                };
            });

            return tempList;
        },

        // Check Approver List !== 결재선 그리드 클릭시 결재자 목록 조회 ==!
        onGridAprvTrgtList: (data: any) => {
            form.aprvRqstPpupInfo.setValue(
                "aprvPrcssPathMgmtId",
                comnUtils.isEmpty(data.rowValues) ? aprvPrcssPathMgmtId : data.rowValues.aprvPrcssPathMgmtId,
            );
            fetch.getAprvTrgtList.fetch();
        },

        onRqstUsrListAdd: () => {
            form.aprvRqstPpupInfo.setValue("aprvIdList", aprvUsrList);
            fetch.getAprvRqstUsrList.fetch(form.aprvRqstPpupInfo.getValues());
        },

        // Add Grid Row !== 그리드 행 추가 버튼 ==!
        onGridBtnAdd: () => {
            modal.openModal({
                url: "/comn/comn/ppup/aprvRqstUsrPpup",
                // !== 결재요청으로 넘겨주는 파라미터(업무분류,신고문서,후처리url,결재참고id) ==!
                params: {
                    bsopClsfCd: "LCM",
                },
                size: "lg",
                draggable: true,
                callback: (data) => {
                    const trgtUsrList = data.trgtUsrList; // Approver Target List !== 결재자 대상 선택 목록 ==!
                    const addList = grid.aprvUsrList.getData({ excludes: ["deleted"] }); // Approver Target Add List !== 결재자 대상 추가 목록 ==!
                    let checkYn = "Y";

                    if (trgtUsrList.length === 0) {
                        modal.openModal({ content: "msg.ptl.00687" }); // Please select a registration target !== 등록대상을 선택하세요. ==!
                        return;
                    }

                    if (trgtUsrList.length === 0) {
                        modal.openModal({ content: "msg.ptl.00687" }); // Please select a registration target !== 등록대상을 선택하세요. ==!
                        return;
                    }

                    const usrList = addList.concat(trgtUsrList);

                    const uniqueObjArr = usrList.filter((obj, idx) => {
                        const isFirstFindIdx = usrList.findIndex((obj2) => obj2.usrDmnId === obj.usrDmnId);
                        return isFirstFindIdx === idx;
                    });

                    if (usrList.length !== uniqueObjArr.length) {
                        checkYn = "N";
                    }

                    trgtUsrList.forEach((item: any, index: any) => {
                        if (checkYn === "Y") {
                            grid.aprvUsrList.addRow({ ...item });
                        }
                    });

                    if (checkYn === "N") {
                        modal.openModal({ content: "msg.00005" }); // Duplicate data exists. !== 중복된 데이터가 존재합니다. ==!
                        return;
                    }
                    modal.closeModal();
                },
            });
        },
        // Delete Grid Row !== 그리드 행 삭제 버튼 ==!
        onGridBtnDel: () => {
            const usrList = grid.aprvUsrList.getChecked();
            if (usrList.length === 0) {
                modal.openModal({ content: "msg.ptl.00683" }); // Please select a destination to delete. !== 삭제대상을 선택하세요. ==!
                return;
            }
            grid.aprvUsrList.deleteRow("checkbox");
        },
        // Grid UpRow Button  !== 버튼 클릭시 그리드 위 이동 ==!
        onGridUpRow: () => {
            const trgtUsrList = grid.aprvUsrList.getChecked();
            if (trgtUsrList.length === 0) {
                modal.openModal({ content: "msg.com.00086" }); // No data has been selected. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            trgtUsrList.forEach((item: any) => grid.aprvUsrList.upRow({ ...item }));
        },
        // Grid DownRow Button !== 버튼 클릭시 그리드 아래 이동 ==!
        onGridDownRow: () => {
            const trgtUsrList = grid.aprvUsrList.getChecked();
            if (trgtUsrList.length === 0) {
                modal.openModal({ content: "msg.com.00086" }); // No data has been selected. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            trgtUsrList.forEach((item: any) => grid.aprvUsrList.downRow({ ...item }));
        },
        oninit: () => {
            fetch.getDclaDocInfo.fetch();
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.oninit();
        tree.tree._tree.current._checkbox = false;
    }, []);

    return (
        <Page title={t("T_APRV_RQST")}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.aprvRqstPpupInfo.schema.aprvRqstTtleNm}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.aprvRqstPpupInfo.schema.aprvRqstCn}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    {aprvUsrMdfyYn !== "N" && (
                        <Layout>
                            <Group>
                                <Group.Body>
                                    <Group.Title title={t("T_APRV_RQST")} titleSize={3} />
                                    <Group.Section>
                                        <Grid
                                            {...grid.aprvPathMgmtList.grid}
                                            data={fetch.getAprvPathMgmtList.data?.aprvPathMgmtList}
                                            onCellClick={handler.onGridAprvTrgtList}
                                        />
                                    </Group.Section>
                                </Group.Body>
                            </Group>
                        </Layout>
                    )}

                    <Layout>
                        <Group>
                            <Group.Body>
                                <Group.Title title={t("T_RSLT_LST")} titleSize={3} />
                                {aprvUsrMdfyYn !== "N" && (
                                    <Group.Section>
                                        <Layout direction="row">
                                            <Layout.Left>
                                                <IconButton
                                                    icon="up"
                                                    size="lg"
                                                    onClick={handler.onGridUpRow}
                                                    title={t("UpRow")}
                                                />
                                                <IconButton
                                                    icon="down"
                                                    size="lg"
                                                    onClick={handler.onGridDownRow}
                                                    title={t("DownRow")}
                                                />
                                            </Layout.Left>
                                            <Layout.Right>
                                                <Button role="gridAdd" onClick={handler.onGridBtnAdd} />
                                                <Button role="gridDelete" onClick={handler.onGridBtnDel} />
                                            </Layout.Right>
                                        </Layout>
                                    </Group.Section>
                                )}
                                <Group.Section>
                                    <Grid {...grid.aprvUsrList.grid} data={fetch.getAprvTrgtList.data?.aprvUsrList} />
                                </Group.Section>
                            </Group.Body>
                        </Group>
                    </Layout>
                    <Layout.Right>
                        <Button variant="primary" onClick={handler.onAprvBtnClick}>
                            {t("B_APRV_RQST")}
                        </Button>
                    </Layout.Right>
                </Group.Body>
            </Group>
        </Page>
    );
};
